import React from 'react';

interface MetadataHeaderProps {
  contextLabel: string;
  helperText: string;
  selector?: React.ReactNode;
  actions: React.ReactNode;
  hasUnsavedChanges?: boolean;
}

const MetadataHeader: React.FC<MetadataHeaderProps> = ({
  contextLabel,
  helperText,
  selector,
  actions,
  hasUnsavedChanges,
}) => (
  <header className="metadata-header book-detail-workspace-header book-detail-primary-surface" data-tour-id="metadata-language">
    <div className="metadata-header-main">
      <div>
        <h2>{contextLabel}</h2>
        <p className="book-detail-helper-text">{helperText}</p>
      </div>
      {hasUnsavedChanges ? <span className="metadata-dirty-pill">Unsaved</span> : null}
    </div>
    <div className="metadata-header-controls">
      {selector ? (
        <div className="metadata-header-context-control">
          {selector}
        </div>
      ) : null}
      <div className="metadata-language-actions" data-tour-id="metadata-ai">
        {actions}
      </div>
    </div>
  </header>
);

export default MetadataHeader;
